import { EquipmentTypeDocument } from '../EquipmentType/queryBuilder';
import { InspectionCategoryDocument } from '../InspectionCategories/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { InspectionOptionsDocument, inspectionOptionsPullQueryBuilder } from './queryBuilder';

export function inspectionOptionsFamilyMember(
  configBuilder: ConfigBuilder,
  equipmentType: FamilyMember<EquipmentTypeDocument>,
  inspectionCategories: FamilyMember<InspectionCategoryDocument>,
): FamilyMember<InspectionOptionsDocument> {
  const syncConfig = configBuilder<InspectionOptionsDocument>(
    RxdbCollectionNameV2.INSPECTION_OPTIONS,
  );
  doNotAutoSync(syncConfig);

  pull(syncConfig, inspectionOptionsPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.INSPECTION_OPTIONS, replicationState, [
    equipmentType,
    inspectionCategories,
  ]);
}
